import React from 'react';
import { useTranslation } from 'react-i18next';
import { locale, unix } from 'moment';
import 'moment/locale/nl';

import CoreLink from '../../../CoreLink';
import type { SearchForumCategoryPostsHit } from '../../../SearchForumCategoryPosts/types';

import './style.scss';

locale('nl');

export interface SearchForumFollowTopicResultsHitProps {
  hit: SearchForumCategoryPostsHit;
}

const SearchForumFollowTopicResultsHit: React.FC<SearchForumFollowTopicResultsHitProps> =
(props) => {
  const { hit } = props;
  const { t } = useTranslation();

  const url = hit.url[0];
  const title = hit.post_title[0];
  const lastCommentTimestamp = hit.post_last_comment_timestamp[0];
  const lastCommentDate = unix(lastCommentTimestamp);
  const commentCount = hit.post_comment_count[0];

  return (
    <div className="SearchForumFollowTopicHit">
      <div className="SearchForumFollowTopicHit__icon">
        <i className="icon icon-bookmark icon-variant-7" />
      </div>

      <div className="SearchForumFollowTopicHit__content">
        <CoreLink
          href={url}
          className="SearchForumFollowTopicHit__title"
        >
          {title}
        </CoreLink>
      </div>

      <div className="SearchForumFollowTopicHit__label">
        <i className="icon icon-clock" />
        <span className="SearchForumFollowTopicHit__label__text">
          {t('pages.forum.follow_forum_topic.last_reaction')}
        </span>
        <span className="SearchForumFollowTopicHit__meta-value">
          {lastCommentTimestamp !== 0 && commentCount !== 0
            ? lastCommentDate.fromNow()
            : t('pages.forum.posts.labels.no_response')}
        </span>
      </div>
    </div>
  );
};

export default SearchForumFollowTopicResultsHit;
